const ES = {
  governmentalOrganization: [
    "corporaciones locales",
    "organismos públicos",
    "órganos de la Administración del Estado y de las Comunidades Autónomas"
  ],
  listedPublicCompany: [
    "listed sociedad anónima (SA)"
  ],
  nonProfit: [
    "sociedad cooperativa (S. Coop.)",
    "fundación",
    "non-profit asociación",
    "",
    "congregaciones e instituciones religiosas"
  ],
  privateCompany: [
    "sociedad limitada unipersonal (SLU)",
    "sociedad de responsabilidad limitada (SRL)",
    "unlisted sociedad anónima (SA)"
  ]
};
export {
  ES as default
};
